export const WEEK_DAY_GROUP = [
    {
        weekNum: 0,
        weekDay: "일",
    },
    {
        weekNum: 1,
        weekDay: "월",
    },
    {
        weekNum: 2,
        weekDay: "화",
    },
    {
        weekNum: 3,
        weekDay: "수",
    },
    {
        weekNum: 4,
        weekDay: "목",
    },
    {
        weekNum: 5,
        weekDay: "금",
    },
    {
        weekNum: 6,
        weekDay: "토",
    },
];
